import React, { useState } from "react";

import { ChartColumn, TrendingUp } from "lucide-react";

export const ScoreTrendAnalysis = () => {

    const [view, setView] = useState<'trend' | 'chart'>('trend');

    return (
        <div className='card card--md card--radius-md card--hover-shadow w-full dashboard__mcsa__score_trend_analysis'>
            <div className='d-flex justify-content-between align-items-center mb-xl'>
                <div>
                    <p className='text-lg text-semibold'>Score Trend Analysis</p>
                    <p className='text-sm color--txt-muted'>30-day performance with industry benchmark</p>
                </div>
                <div className='d-flex align-items-center gap-sm'>
                    <button
                        className={`btn btn--icon-md btn--radius-sm btn--secondary ${view === 'trend' ? 'btn--selected' : ''}`}
                        onClick={() => setView('trend')}
                    >
                        <TrendingUp />
                    </button>
                    <button
                        className={`btn btn--icon-md btn--radius-sm btn--secondary ${view === 'chart' ? 'btn--selected' : ''}`}
                        onClick={() => setView('chart')}
                    >
                        <ChartColumn />
                    </button>
                </div>
            </div>
            <ScoreTrendChart />
            <div className="d-flex justify-content-between gap-lg">
                <div className="d-flex align-items-center gap-lg">
                    <div className="d-flex align-items-center gap-sm">
                        <div className='w-md h-md br-full bg--primary' />
                        <p className="text-sm color--txt-tertiary text-medium">Organization Score</p>
                    </div>
                    <div className="d-flex align-items-center gap-sm">
                        <div className='w-md h-md br-full bg--warning' />
                        <p className="text-sm color--txt-tertiary text-medium">Industry Benchmark</p>
                    </div>
                </div>
                <div className="d-flex align-items-center gap-lg">
                    <div className="d-flex flex-column align-items-center">
                        <p className="text-md text-medium">+2.3%</p>
                        <p className="text-sm color--txt-tertiary text-medium text-center">vs Last Week</p>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                        <p className="text-md text-medium">-4.7%</p>
                        <p className="text-sm color--txt-tertiary text-medium text-center">vs Benchmark</p>
                    </div>
                </div>
            </div>
        </div>
    );
};




const orgData = [58, 65, 72, 70, 78, 74, 80, 73, 68, 71, 64, 60, 55, 48, 52, 45, 47, 50, 48, 54];
const benchmarkData = [68, 69, 70, 71, 72, 73, 73, 72, 71, 70, 69, 68, 67, 66, 65, 64, 63, 62, 61, 60];
// pathUtils.ts
const createZigZagPath = (data: number[], width: number, height: number, padding = 24) => {
    const max = Math.max(...data);
    const min = Math.min(...data);

    return data.reduce((path, value, i) => {
        const x =
            padding + (i * (width - padding * 2)) / (data.length - 1);
        const y =
            padding + ((max - value) / (max - min)) * (height - padding * 2);

        return i === 0 ? `M ${x} ${y}` : `${path} L ${x} ${y}`;
    }, "");
};

const createSmoothPath = (data: number[], width: number, height: number, padding = 24) => {
    const max = Math.max(...data);
    const min = Math.min(...data);

    const points = data.map((value, i) => ({
        x: padding + (i * (width - padding * 2)) / (data.length - 1),
        y:
            padding +
            ((max - value) / (max - min)) * (height - padding * 2),
    }));

    let d = `M ${points[0].x} ${points[0].y}`;

    for (let i = 1; i < points.length; i++) {
        const prev = points[i - 1];
        const curr = points[i];
        const cx = (prev.x + curr.x) / 2;

        d += ` C ${cx} ${prev.y}, ${cx} ${curr.y}, ${curr.x} ${curr.y}`;
    };

    return d;
};

const GridLines = ({ width, height, lines = 4 }: any) => {
    const gap = height / (lines + 1);

    return (
        <>
            {Array.from({ length: lines }).map((_, i) => (
                <line
                    key={i}
                    x1={0}
                    x2={width}
                    y1={(i + 1) * gap}
                    y2={(i + 1) * gap}
                    stroke="rgba(0,0,0,0.08)"
                    strokeWidth={1}
                />
            ))}
        </>
    );
};
const WIDTH = 480;
const HEIGHT = 256;
const ScoreTrendChart = () => {
    // const smoothPath = createSmoothPath(orgData, WIDTH, HEIGHT);
    const zigZagPath = createZigZagPath(orgData, WIDTH, HEIGHT);
    const benchmarkPath = createSmoothPath(benchmarkData, WIDTH, HEIGHT);

    return (
        <svg viewBox={`0 0 ${WIDTH} ${HEIGHT}`} width="100%" height={HEIGHT}>
            <defs>
                <linearGradient id="purpleGradient" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#C4B5FD" />
                    <stop offset="100%" stopColor="#7C3AED" />
                </linearGradient>

                <filter id="glow">
                    <feGaussianBlur stdDeviation="5" result="blur" />
                    <feMerge>
                        <feMergeNode in="blur" />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
            </defs>

            {/* Grid */}
            <GridLines width={WIDTH} height={HEIGHT} />

            {/* Benchmark (orange smooth) */}
            <path
                d={benchmarkPath}
                fill="none"
                stroke="#FBBF24"
                strokeWidth={3}
                opacity={0.9}
            />

            {/* Purple zig-zag base */}
            <path
                d={zigZagPath}
                fill="none"
                stroke="url(#purpleGradient)"
                strokeWidth={4}
                filter="url(#glow)"
            />

            {/* Purple smooth glow */}
            {/* <path
                    d={smoothPath}
                    fill="none"
                    stroke="url(#purpleGradient)"
                    strokeWidth={4}
                    filter="url(#glow)"
                /> */}
        </svg>
    );
};
